import React from "react";
import {Button, ButtonGroup, Checkbox, Col, ControlLabel, Row} from "react-bootstrap";
import FieldGroup from "../../../../components/FieldGroup";
import SelectWrap from "../../../../components/SelectWrap";
import countriesObj from "../../../../data/countries";
import {handleFieldChange} from "../../../../Utils";

const countriesOptions = Object.assign({ all: 'All' }, countriesObj);

class ContentForYouForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            date: null,
            groupBy: [],
            dateFrom: null,
            dateTo: null,
            hourFrom: null,
            hourTo: null,
            affid: null,
            source: null,
            country: null
        }

        this.handleFieldChange = handleFieldChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleGroupByChange = this.handleGroupByChange.bind(this);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if((prevState.date !== this.state.date) && this.state.date) {
            this.handleFormSubmit('filters')
        }
    }


    handleFormSubmit(type) {
        console.log(this.state)
        this.props.handleSubmitButton({ ...this.state, groupBy: this.state.groupBy.length > 0 ? this.state.groupBy : null }, type)
    }

    handleGroupByChange({ target }) {
        let groupBy = this.state.groupBy;

        if(target.checked) groupBy.push(target.name);
        else groupBy = groupBy.filter(pred => pred !== target.name);

        this.setState({ groupBy });
    }

    render() {
        return (
            <div>
                {
                    this.props.groupBy && (
                        <Row>
                            <Col lg={12}>
                                <ControlLabel>Group By:</ControlLabel>

                                {this.props.groupBy.map(({ name, title }) => <Checkbox onChange={this.handleGroupByChange} name={name}>{title}</Checkbox>)}
                            </Col>
                        </Row>
                    )
                }

                <Row>
                    <Col lg={2}>
                        {
                            this.props.type === "daily" ? (
                                <div style={{ display: 'flex' }}>
                                    <div style={{ marginRight: '10px' }}>
                                        <FieldGroup
                                            type="date"
                                            name="dateFrom"
                                            label="Date From:"
                                            onChange={this.handleFieldChange}
                                            value={this.state.dateFrom}
                                        />
                                    </div>

                                    <div>
                                        <FieldGroup
                                            type="date"
                                            name="dateTo"
                                            label="Date To:"
                                            onChange={this.handleFieldChange}
                                            value={this.state.dateTo}
                                        />
                                    </div>
                                </div>
                            ) : (
                                <FieldGroup
                                    type="date"
                                    name="date"
                                    label="Date:"
                                    onChange={this.handleFieldChange}
                                    value={this.state.date}
                                />
                            )
                        }
                    </Col>

                    {
                        this.props.type === "hourly" && (
                            <div>
                                <Col lg={2}>
                                    <FieldGroup
                                        type="number"
                                        name="hourFrom"
                                        label="Hour From:"
                                        min={0}
                                        max={23}
                                        onChange={this.handleFieldChange}
                                        value={this.state.hourFrom}
                                    />
                                </Col>

                                <Col lg={2}>
                                    <FieldGroup
                                        type="number"
                                        name="hourTo"
                                        label="Hour To:"
                                        min={0}
                                        max={23}
                                        onChange={this.handleFieldChange}
                                        value={this.state.hourTo}
                                    />
                                </Col>
                            </div>
                        )
                    }


                </Row>

                <Row>
                    <Col lg={3}>
                        <SelectWrap
                            values={this.props.sourceValues}
                            label="Source:"
                            name="source"
                            onChange={this.handleFieldChange}
                            value={this.state.source}
                            disabled={!this.props.sourceValues.length}
                            multi
                            required
                        />
                    </Col>

                    <Col lg={3}>
                        <SelectWrap
                            values={this.props.affidValues}
                            label="Affid:"
                            name="affid"
                            onChange={this.handleFieldChange}
                            value={this.state.affid}
                            disabled={!this.props.affidValues.length}
                            multi
                            required
                        />
                    </Col>

                    <Col lg={3}>
                        <SelectWrap
                            values={countriesOptions}
                            label="Countries:"
                            name="country"
                            onChange={this.handleFieldChange}
                            value={this.state.country}
                            multi
                            required
                        />
                    </Col>
                </Row>

                {
                    this.props.children
                }

                <ButtonGroup style={{ marginTop: '5px', marginBottom: '5px' }}>
                    <Button onClick={() => this.handleFormSubmit()} bsStyle={'primary'}>Load</Button>
                </ButtonGroup>
            </div>
        )
    }
}

export default ContentForYouForm;


// WEBPACK FOOTER //
// ./src/scenes/ContentForYouDaily/components/ContentForYouForm/index.js